<template>
    <div>
        <Wp_nav_bar title="提款"></Wp_nav_bar>
        <div v-if="$common.canShowTaobao() && $common_tb.getTaobaoPid()">
            <div v-if="$common.canShowPdd()">
                <van-tabs v-model="active_whole" sticky title-active-color="#219EFF">
                    <van-tab>
                        <div slot="title"><h3>京东</h3></div>
                        <Wp_jd_pay_data></Wp_jd_pay_data>
                    </van-tab>
                    <van-tab>
                        <div slot="title"><h3>淘宝</h3></div>
                        <Wp_tb_pay_data></Wp_tb_pay_data>
                    </van-tab>
                    <van-tab>
                        <div slot="title"><h3>拼多多</h3></div>
                        <Wp_pdd_pay_data></Wp_pdd_pay_data>
                    </van-tab>
                </van-tabs>
            </div>
            <div v-else>
                <van-tabs v-model="active_whole" sticky title-active-color="#219EFF">
                    <van-tab>
                        <div slot="title"><h3>京东</h3></div>
                        <Wp_jd_pay_data></Wp_jd_pay_data>
                    </van-tab>
                    <van-tab>
                        <div slot="title"><h3>淘宝</h3></div>
                        <Wp_tb_pay_data></Wp_tb_pay_data>
                    </van-tab>
                </van-tabs>
            </div>
        </div>
        <div v-else>
            <div v-if="$common.canShowPdd()">
                <van-tabs v-model="active_whole" sticky title-active-color="#219EFF">
                    <van-tab>
                        <div slot="title"><h3>京东</h3></div>
                        <Wp_jd_pay_data></Wp_jd_pay_data>
                    </van-tab>
                    <van-tab>
                        <div slot="title"><h3>拼多多</h3></div>
                        <Wp_pdd_pay_data></Wp_pdd_pay_data>
                    </van-tab>
                </van-tabs>
            </div>
            <div v-else>
                <Wp_jd_pay_data></Wp_jd_pay_data>
            </div>

        </div>

    </div>
</template>

<script>
    import Vue from 'vue';
    import {Alert} from 'iview';
    import {Dialog} from 'vant';
    import Wp_nav_bar from "../custom/Wp_nav_bar";
    import Wp_jd_pay_data from "./Wp_jd_pay_data";
    import Wp_tb_pay_data from "../tb/pages_childs/Wp_tb_pay_data";
    import Wp_pdd_pay_data from "../pdd/pages_childs/Wp_pdd_pay_data";

    Vue.component('Alert', Alert);

    export default {
        name: "Wp_my_pay_data",
        components: {Wp_pdd_pay_data, Wp_tb_pay_data, Wp_jd_pay_data, Wp_nav_bar},
        data() {
            return {
                active_whole: 0,
            }
        },

        created() {
            if(this.$common_tb.pay_from_tb_data_page){
                this.active_whole = 1;
                this.$common_tb.pay_from_tb_data_page = false;
            }
        },
    }
</script>

<style scoped>

</style>
